module.exports = __webpack_public_path__ + "static/media/galeria-fotos-1.8aaf51ba.png";